import mitt from 'mitt';

type Events = {
    "sorting-updated": void;
    "filter-reset": void;
};

export const eventBus = mitt<Events>();